import React from 'react';
import Helmet from 'react-helmet'

const SEO = (props) => {
	console.log(props)
  return (
    <div>
    	<Helmet
	      title={props.titleSection}
	      meta={[
				{name:"description", content:props.metaDescription},
				{name:"image", content:"http://www.remagencia.com/images/about-gallery.png"},
				{itemprop:"name", content:"Rem Agencia"},
				{name:"twitter:card", content:"summary"},
				{name:"twitter:title", content:"Rem Agencia"},
				{name:"twitter:description", content:props.metaDescription},
				{name:"twitter:image:src", content:"http://www.remagencia.com/images/about-gallery.png"},
				{name:"og:title", content:"Rem Agencia"},
				{name:"og:description", content:props.metaDescription},
				{name:"og:image", content:"http://www.remagencia.com/images/about-gallery.png"},
				{name:"og:url", content:"http://www.remagencia.com"},
				{name:"og:site_name", content:"Rem Agencia"},
				{name:"og:locale", content:"en_ES"},
				{name:"og:type", content:"website"},
	      ]}
	    />
    </div>
  )
}

export default SEO;


// WEBPACK FOOTER //
// ./src/components/seo.js